export default "__VITE_ASSET__xVzpV8Sf__"